import { Grid2 } from "@mui/material";
import Loader from "../../../../components/Loader";
import { useEffect, useState } from "react";
import ResupplySwitch from "../../../../components/CustomSwitch/ResupplySwitch";
import StyledGridComp from "../../../../components/StyledGridComp";
import { useNavigate } from "react-router-dom";
import {
  getOnLoadDataForSiteLanguagesService,
  submitSiteLanguagesDataService,
} from "../../../../services/siteManagamentService";
import { notifyError, notifySuccess } from "../../../../utilities/helper";

const SiteLanguages = ({ siteId }) => {
  const [load, setLoad] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [rowData, setRowData] = useState([]);
  const [rowLength, setRowLength] = useState(0);
  const [siteNumber, setSiteNumber] = useState("");

  const navigate = useNavigate();

  const access_token = localStorage?.getItem("access_token");
  const roleId = localStorage.getItem("roleId");

  useEffect(() => {
    if (siteId) {
      getOnLoadData(siteId);
    }
  }, [siteId]);

  const handleSwitchChange = (value, id, field) => {
    const scrollY = window.scrollY;
    setRowData((prev) =>
      prev.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
    setTimeout(() => window.scrollTo(0, scrollY), 0);
  };

  const columns = [
    {
      field: "name",
      headerName: "Culture Name",
      width: 300,
      renderHeader: () => <div className="grid-heading">{"Culture Name"}</div>,
      renderCell: (params) => {
        const name = params.row.name;

        return <span>{name}</span>;
      },
    },
    {
      field: "description",
      headerName: "Description",
      width: 400,
      renderHeader: () => <div className="grid-heading">{"Description"}</div>,
      renderCell: (params) => {
        const description = params.row.description;

        return <span>{description}</span>;
      },
    },
    {
      field: "notes",
      headerName: "Notes",
      width: 350,
      renderHeader: () => <div className="grid-heading">{"Notes"}</div>,
      renderCell: (params) => {
        const notes = params.row.notes;

        return <span>{notes}</span>;
      },
    },
    {
      field: "selected",
      headerName: "Active",
      width: 250,
      filterable: false,
      renderHeader: () => <div className="grid-heading">{"Active"}</div>,
      renderCell: (params) => {
        const selected = params.row.selected;

        return (
          <div style={{ marginTop: "8px" }}>
            <ResupplySwitch
              value={selected}
              onChange={(val) =>
                handleSwitchChange(val, params.row.id, "selected")
              }
            />
          </div>
        );
      },
    },
  ];

  const getOnLoadData = async (siteId) => {
    try {
      setLoad(true);
      const res = await getOnLoadDataForSiteLanguagesService(
        access_token,
        siteId
      );
      if (
        res?.status === 200 &&
        res?.data?.message === "Onload data extracted for Site Language Tab!"
      ) {
        setRowData(res?.data?.result?.languageList);
        setRowLength(res?.data?.result?.languageList?.length || 0);
        setSiteNumber(res?.data?.result?.site?.siteNumber || "");
      }
    } catch (err) {
      console.log("Error in fetching site languages data:", err);
      if (err?.status === 401) {
        navigate("/unauthorize");
      }
    } finally {
      setLoad(false);
    }
  };

  const submitLanguageData = async () => {
    const payload = rowData?.map((item) => ({
      langId: item?.id,
      name: item?.name,
      isSelected: item?.selected,
    }));

    try {
      setLoad(true);
      const res = await submitSiteLanguagesDataService(
        access_token,
        siteId,
        siteNumber,
        roleId,
        payload
      );
      if (res?.status === 200 && res?.data?.message === "Updated!") {
        getOnLoadData(siteId);
        notifySuccess("Site Language Details Updated Successfully !");
      }
    } catch (err) {
      console.log("Error in submitting site languages data:", err);
      notifyError(
        err?.data?.message || "Error in submitting site languages data"
      );
      if (err?.status === 401) {
        navigate("/unauthorize");
      }
    } finally {
      setLoad(false);
    }
  };

  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <>
          <Grid2
            container
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: "100%", marginTop: "-2%" }}
          >
            <Grid2 item md={4}>
              <p className="page-heading">Site Languages</p>
            </Grid2>
          </Grid2>

          {/* Table data */}
          <StyledGridComp
            rows={rowData}
            columns={columns}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            isPaginationClientSide={true}
            length={rowLength}
          ></StyledGridComp>

          <Grid2
            alignItems={"end"}
            justifyContent="end"
            container
            gap={3}
            sx={{ marginTop: "2%" }}
          >
            <Grid2 item md={6}>
              <button className="create-btn" onClick={submitLanguageData}>
                Save
              </button>
            </Grid2>
          </Grid2>
        </>
      )}
    </>
  );
};

export default SiteLanguages;
